<script setup lang="ts">
import { useKeycloak } from "@josempgon/vue-keycloak";
import { RouterView } from "vue-router";
import { useLanguage } from "./composables/useLanguage";
import VersionDisplay from "./components/VersionDisplay.vue";

const { isAuthenticated } = useKeycloak();

const { translate } = useLanguage({
  en: {
    success: "Operation successful",
    error: "An unexpected error occurred. Please try again or contact support if the problem persists.",
    info: "Information",
    warning: "Warning",
  },
  nl: {
    success: "Operatie geslaagd",
    error:
      "Er is een onverwachte fout opgetreden. Probeer het opnieuw of neem contact op met de ondersteuning als het probleem aanhoudt.",
    info: "Informatie",
    warning: "Waarschuwing",
  },
});
</script>

<template>
  <div v-if="isAuthenticated">
    <RouterView />
  </div>
</template>
